import { css } from 'styled-components'
import * as colors from './_variables.styles'

export const h1_xL = 'clamp(4.8rem, 6.5vw, 8.8rem)'
export const h1_L = 'clamp(4.4rem, 6vw, 7.2rem)'
export const h1_M = 'clamp(4rem, 7vw, 6.2rem)'
export const h1_xS = 'clamp(3.4rem, 10vw, 4.8rem)'
export const h1_xxS = 'clamp(3rem, 10vw, 4.2rem)'
export const h2_xL = 'clamp(3.6rem, 4.2vw, 5.8rem)'
export const h2_L = 'clamp(3.4rem, 4vw, 5.2rem)'
export const h2_M = 'clamp(3rem, 5vw, 4.4rem)'
export const h2_xS = 'clamp(2.7rem, 7vw, 3.6rem)'
export const h2_xxS = 'clamp(2.5rem, 7vw, 3.3rem)'
export const h3_xL = 'clamp(2.6rem, 3vw, 3.8rem)'
export const h3_L = 'clamp(2.5rem, 3vw, 3.6rem)'
export const h3_M = 'clamp(2.4rem, 4vw, 3.2rem)'
export const h3_S = '2.6rem'
export const h3_xS = '2.4rem'
export const h3_xxS = '2.2rem'
export const h4_xL = '2.4rem'
export const h4_L = '2.2rem'
export const h4_M = '2rem'
export const h4_xS = '1.8rem'
export const h4_xxS = '1.7rem'
export const h5_xL = '2rem'
export const h5_L = '1.9rem'
export const h5_M = '1.8rem'
export const h5_xS = '1.7rem'
export const h5_xxS = '1.6rem'
export const p_xL = '1.8rem'
export const p_L = '1.7rem'
export const p_M = '1.7rem'
export const p_xS = '1.6rem'
export const p_xxS = '1.6rem'
export const menu_p_xL = '1.6rem'
export const menu_p_L = '1.5rem'
export const menu_p_M = '1.5rem'
export const menu_p_xS = '1.4rem'
export const menu_p_xxS = '1.4rem'
export const smallP_xL = '1.5rem'
export const smallP_L = '1.5rem'
export const smallP_M = '1.4rem'
export const smallP_xS = '1.4rem'
export const smallP_xxS = '1.3rem'
export const xsmallP_xL = '1.3rem'
export const xsmallP_L = '1.3rem'
export const xsmallP_M = '1.2rem'
export const xsmallP_xS = '1.2rem'
export const xsmallP_xxS = '1.1rem'

const colorMap = { primary: colors.warmPalette.primaryDark, secondary: colors.warmPalette.textAccent, tertiary: colors.warmPalette.primaryDark, contrast: colors.warmPalette.contrast, white: colors.white, black: colors.black }
export const font_color_P_S_T_W_B = css`color: ${({ color }) => colorMap[color] || colors.font_black};`
export const textAlign = css`text-align: ${({ left, center, right }) => left ? 'left' : center ? 'center' : right ? 'right' : 'left'};`
